module.exports = __webpack_public_path__ + "img/Shiba-BG1.a9cabef2.jpg";